import React from 'react';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import FormatAlignLeftIcon from '@material-ui/icons/FormatAlignLeft';
import FormatAlignCenterIcon from '@material-ui/icons/FormatAlignCenter';
import CreateIcon from '@material-ui/icons/Create';
import GpsFixedIcon from '@material-ui/icons/GpsFixed';
import EcoIcon from '@material-ui/icons/Eco';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';

import FertilizerVegetation from './vegetation/FertilizerVegetation';
import FertilizerPerformance from './performancemap/FertilizerPerformance';
import { useAuth } from '../../../../context/AuthContext';

const useStyles = makeStyles((theme) => ({
    paper: {
        display: 'flex',
        border: `1px solid ${theme.palette.divider}`,
        flexWrap: 'wrap',
        marginBottom: theme.spacing(1)
    },
    text: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
}));

const StyledToggleButtonGroup = withStyles((theme) => ({
    grouped: {
        margin: theme.spacing(0.5),
        border: 'none',
        '&:not(:first-child)': {
            borderRadius: theme.shape.borderRadius,
        },
        '&:first-child': {
            borderRadius: theme.shape.borderRadius,
        },
    },
}))(ToggleButtonGroup);

function Fertilizer(props) {
    const [alignment, setAlignment] = React.useState('vegetation');
    const { loggedUser } = useAuth();

    const handleAlignment = (event, newAlignment) => {
        setAlignment(newAlignment);
    };

    const classes = useStyles();

    return (
        <div>
            <Grid container spacing={2} direction="column" alignItems="center">
                <Grid item>
                    <Paper elevation={0} className={classes.paper}>
                        <StyledToggleButtonGroup
                            size="small"
                            value={alignment}
                            exclusive
                            onChange={handleAlignment}
                            aria-label="text alignment"
                        >
                            <ToggleButton value="vegetation" aria-label="vegetation index">
                                <EcoIcon />
                                <Typography className={classes.text}>Vegetation Index</Typography>
                            </ToggleButton>
                            <ToggleButton value="performance" aria-label="performance map">
                                <GpsFixedIcon />
                                <Typography className={classes.text}>Performance Map</Typography>
                            </ToggleButton>

                            {/* <ToggleButton value="manual" aria-label="manual mode">
                                <CreateIcon />
                                <Typography className={classes.text}>Manual mode</Typography>
                            </ToggleButton> */}
                        </StyledToggleButtonGroup>
                    </Paper>
                </Grid>
            </Grid>
            {alignment === 'vegetation' && <FertilizerVegetation {...props} />}
            {alignment === 'performance' && <FertilizerPerformance {...props}/>}
            {alignment === 'manual' && <FertilizerPerformance {...props}/>}
        </div>
    );
}

export default withWidth()(Fertilizer);